import { create } from 'zustand';

// ─────────────────────────────────────────────────────────────────────────────
// walletStore — fonte única de verdade, no cliente, do saldo "Ta Feito" do
// jogador (a moeda da barra do topo, da Forja e do Mercador). Todo componente
// que exibe o saldo lê daqui para refletir compra/venda/forja EM TEMPO REAL,
// sem re-fetch.
//
// Regra: qualquer resposta de API que traga o saldo deve chamar `setBalance`.
// `bumpInventory` força quem lista a mochila a recarregar (itens mudaram).
// ─────────────────────────────────────────────────────────────────────────────

interface WalletState {
  /** Saldo atual de Ta Feito. `null` até a primeira leitura de uma API. */
  balance: number | null;
  /** Contador que muda sempre que a mochila é alterada (compra/venda/forja). */
  inventoryNonce: number;
  setBalance: (n: number) => void;
  bumpInventory: () => void;
}

export const useWalletStore = create<WalletState>((set) => ({
  balance: null,
  inventoryNonce: 0,
  setBalance: (n) => set({ balance: Number.isFinite(n) ? n : 0 }),
  bumpInventory: () => set((s) => ({ inventoryNonce: s.inventoryNonce + 1 })),
}));
